module.exports = __webpack_public_path__ + "img/icon-3.810b4d40.png";